interface PullTableColumn {
  name?: string;
}

interface PullTableConfig {
  COLUMNS?: PullTableColumn[];
}

export const getIncrementalTimestampColumns = (
  tableConfig: PullTableConfig
): string[] => {
  const columns = Array.isArray(tableConfig.COLUMNS)
    ? tableConfig.COLUMNS.map(column => column.name)
    : [];

  return ['created_at', 'updated_at'].filter(column => columns.includes(column));
};
